const variantProductCodes = new Map();

const originalFetch = window.fetch.bind(window);
const fishWishlistElements = new Set([
  'ATW-DRAWER',
  'ATW-DRAWER-ITEM',
  'BUY-ALL-BUTTON',
  'FW2-DRAWER',
  'FW2-ITEM-ROW',
  'FW2-LIST-CARD',
  'REQUEST-QUOTE-BUTTON',
  'WISHLIST-ITEM-CARD',
  'WISHLIST-VARIANT-SELECTOR',
  'WISHLISTS-DRAWER',
]);

let fishCartIntentExpiresAt = 0;
let fishCartRefreshTimer;

function isFishWishlistInteraction(event) {
  return event.composedPath().some((node) => node instanceof Element && fishWishlistElements.has(node.tagName));
}

function rememberFishCartIntent(event) {
  if (!isFishWishlistInteraction(event)) return;
  fishCartIntentExpiresAt = Date.now() + 15000;
}

function isCartAddRequest(input) {
  const requestUrl = input instanceof Request ? input.url : String(input);

  try {
    const url = new URL(requestUrl, window.location.origin);
    const root = window.Shopify?.routes?.root || '/';
    const cartAddPath = `${root.replace(/\/$/, '')}/cart/add`.replace(/\/+/g, '/');
    return url.origin === window.location.origin && url.pathname.replace(/\.js$/, '') === cartAddPath;
  } catch {
    return false;
  }
}

function queueHorizonCartRefresh() {
  window.clearTimeout(fishCartRefreshTimer);
  fishCartRefreshTimer = window.setTimeout(async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await originalFetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error(`Unable to fetch basket: ${response.status}`);

      const cart = await response.json();
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          composed: true,
          detail: { cart },
        })
      );
    } catch (error) {
      console.warn('[BPT Fish Wishlist] Unable to refresh the basket UI.', error);
    }
  }, 250);
}

// Fish adds wishlist items through Shopify's Ajax Cart API, but it does not
// notify Horizon after the request succeeds. Track cart requests initiated
// from Fish and hand the updated cart to the existing Horizon compatibility
// bridge in qty-global.js. This is deliberately scoped to Fish interactions so
// native product forms do not receive a duplicate cart update.
document.addEventListener('click', rememberFishCartIntent, true);
document.addEventListener('submit', rememberFishCartIntent, true);

window.fetch = async (...args) => {
  const isFishCartAdd = Date.now() < fishCartIntentExpiresAt && isCartAddRequest(args[0]);
  const response = await originalFetch(...args);

  if (isFishCartAdd && response.ok) {
    queueHorizonCartRefresh();
  }

  return response;
};

const fishWishlistCopy = new Map([
  ['Add to quote', 'Add to favourites'],
  ['My quotes', 'My favourites'],
  ['My Quotes', 'My favourites'],
  ['Your existing quotes', 'Your existing lists'],
  ['YOUR EXISTING QUOTES', 'YOUR EXISTING LISTS'],
]);

const fishWishlistStyle = document.createElement('style');
fishWishlistStyle.dataset.bptFishWishlist = 'true';
fishWishlistStyle.textContent = `
  wishlists-drawer .price-container s,
  wishlists-drawer .price-container del,
  wishlists-drawer .price-container .compare-at-price,
  wishlists-drawer .price-container [class*="compare-at"],
  atw-drawer .price-container s,
  atw-drawer .price-container del,
  atw-drawer .price-container .compare-at-price,
  atw-drawer .price-container [class*="compare-at"],
  fw2-drawer .fw2-price s,
  fw2-drawer .fw2-price del,
  fw2-drawer .fw2-price [class*="compare-at"] {
    display: none !important;
  }

  fw2-drawer buy-all-button[hidden] {
    display: none !important;
  }

  /* Fish Wishlist 2.0 — restrained Birchwood Price Tools treatment. */
  fw2-drawer .fw2-panel {
    background: #fff !important;
    color: #111 !important;
    font-family: var(--font-body--family, Roboto, Arial, sans-serif) !important;
    border: 1px solid #dfe3e6 !important;
    border-radius: 12px !important;
    box-shadow: -12px 0 36px rgb(0 0 0 / 14%) !important;
  }

  fw2-drawer .fw2-header {
    border-bottom: 1px solid #dfe3e6 !important;
  }

  fw2-drawer .fw2-tabs {
    background: #f4f6f7 !important;
    border-radius: 4px !important;
  }

  fw2-drawer .fw2-tab {
    border-radius: 3px !important;
    font-family: var(--font-heading--family, Montserrat, Arial, sans-serif) !important;
    font-weight: 700 !important;
  }

  fw2-drawer .fw2-tab.is-active {
    background: #000 !important;
    color: #fff !important;
  }

  fw2-drawer .fw2-card,
  fw2-drawer .fw2-panel-card,
  fw2-drawer .fw2-row__image {
    border-color: #dfe3e6 !important;
    border-radius: 4px !important;
    background: #fff !important;
  }

  fw2-drawer .fw2-card__name,
  fw2-drawer .fw2-greeting__title,
  fw2-drawer .fw2-row__title {
    color: #111 !important;
    font-family: var(--font-heading--family, Montserrat, Arial, sans-serif) !important;
    font-weight: 700 !important;
  }

  fw2-drawer .fw2-price__now {
    color: #111 !important;
    font-weight: 700 !important;
  }

  fw2-drawer .fw2-btn--solid,
  fw2-drawer .fw2-atc,
  fw2-drawer buy-all-button {
    border-color: #00bcff !important;
    border-radius: 3px !important;
    background: #00bcff !important;
    color: #000 !important;
    font-family: var(--font-heading--family, Montserrat, Arial, sans-serif) !important;
    font-weight: 750 !important;
    text-transform: none !important;
  }

  fw2-drawer .fw2-btn--solid:hover,
  fw2-drawer .fw2-atc:hover,
  fw2-drawer buy-all-button:hover {
    border-color: #00a8e6 !important;
    background: #00a8e6 !important;
    color: #000 !important;
  }

  fw2-drawer .fw2-btn--link,
  fw2-drawer .fw2-link,
  fw2-drawer .fw2-share a {
    color: #007fab !important;
    font-weight: 650 !important;
    text-underline-offset: 3px !important;
  }

  fw2-drawer .fw2-close,
  fw2-drawer .fw2-back,
  fw2-drawer .fw2-icon-btn {
    color: #111 !important;
  }

  fw2-drawer .fw2-close:focus-visible,
  fw2-drawer .fw2-back:focus-visible,
  fw2-drawer .fw2-icon-btn:focus-visible,
  fw2-drawer .fw2-btn:focus-visible,
  fw2-drawer buy-all-button:focus-visible {
    outline: 3px solid #00bcff !important;
    outline-offset: 2px !important;
  }
`;
document.head.append(fishWishlistStyle);

function updateFishWishlistCopy(root = document) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  nodes.forEach((node) => {
    if (node.parentElement?.closest('script, style')) return;
    let text = node.nodeValue;
    fishWishlistCopy.forEach((replacement, original) => {
      text = text.replaceAll(original, replacement);
    });
    text = text
      .replace(/\bquotes\b/g, 'lists')
      .replace(/\bQuotes\b/g, 'Lists')
      .replace(/\bquote\b/g, 'list')
      .replace(/\bQuote\b/g, 'List');
    if (text !== node.nodeValue) node.nodeValue = text;
  });
}

async function getProductCode(variantId) {
  if (!variantId) return '';
  if (!variantProductCodes.has(variantId)) {
    variantProductCodes.set(
      variantId,
      fetch(`${window.Shopify?.routes?.root || '/'}variants/${variantId}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .then((variant) => variant?.sku || '')
        .catch(() => '')
    );
  }
  return variantProductCodes.get(variantId);
}

async function addProductCode(target, variantId, insertBefore = null) {
  if (!target || target.querySelector(':scope > .bpt-fish-product-code')) return;
  const code = await getProductCode(variantId);
  if (!code || !target.isConnected || target.querySelector(':scope > .bpt-fish-product-code')) return;

  const productCode = document.createElement('p');
  productCode.className = 'bpt-fish-product-code';
  productCode.textContent = `Product code: ${code}`;
  target.insertBefore(productCode, insertBefore);
}

function suppressCompareAtPrices(drawer) {
  drawer
    .querySelectorAll(
      '.price-container s, .price-container del, .price-container .compare-at-price, ' +
        '.price-container [class*="compare-at"], .fw2-price s, .fw2-price del, .fw2-price [class*="compare-at"]'
    )
    .forEach((price) => {
      price.hidden = true;
      price.setAttribute('aria-hidden', 'true');
      price.style.setProperty('display', 'none', 'important');
    });

  drawer.querySelectorAll('.price-container span, .fw2-price span').forEach((price) => {
    if (!getComputedStyle(price).textDecorationLine.includes('line-through')) return;
    price.hidden = true;
    price.setAttribute('aria-hidden', 'true');
    price.style.setProperty('display', 'none', 'important');
  });
}

function enhanceFishWishlist2(drawer) {
  updateFishWishlistCopy(drawer);
  suppressCompareAtPrices(drawer);

  drawer.querySelectorAll('fw2-item-row[data-id]').forEach((row) => {
    const details = row.querySelector('.fw2-row__details');
    addProductCode(details, row.dataset.id, details?.querySelector('.fw2-price'));
  });

  drawer.querySelectorAll('fw2-list-card').forEach((card) => {
    const itemCount = card.querySelectorAll('fw2-item-row').length;
    const buyAllButton = card.querySelector('buy-all-button');
    if (!buyAllButton) return;

    const shouldHide = itemCount < 2;
    buyAllButton.hidden = shouldHide;
    buyAllButton.setAttribute('aria-hidden', String(shouldHide));
  });
}

function enhanceFishWishlist(root = document) {
  root.querySelectorAll('wishlists-drawer, atw-drawer').forEach((drawer) => {
    updateFishWishlistCopy(drawer);
    suppressCompareAtPrices(drawer);
  });
  root.querySelectorAll('wishlist-item-card[data-id]').forEach((card) => {
    addProductCode(card.querySelector('.item-card__details'), card.dataset.id);
  });

  root.querySelectorAll('wishlist-variant-selector').forEach((selector) => {
    const variantElement = selector.querySelector('[data-variant-id]');
    addProductCode(selector.querySelector('.wishlist-variant-selector__titles'), variantElement?.dataset.variantId);
  });

  root.querySelectorAll('atw-drawer-item[data-current-variant-id]').forEach((item) => {
    addProductCode(item.querySelector('.atw-drawer__item-name'), item.dataset.currentVariantId);
  });

  root.querySelectorAll('fw2-drawer').forEach(enhanceFishWishlist2);
}

let wishlistEnhancementQueued = false;
const wishlistObserver = new MutationObserver(() => {
  if (wishlistEnhancementQueued) return;
  wishlistEnhancementQueued = true;
  requestAnimationFrame(() => {
    wishlistEnhancementQueued = false;
    enhanceFishWishlist();
  });
});

wishlistObserver.observe(document.documentElement, { childList: true, subtree: true });
enhanceFishWishlist();